export const basicVars = {
    body: document.querySelector('body'),
    hidden: 'hidden',
    shown: 'shown',
}
